import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/en/services/toxicology/residual-solvents-reports")({
  beforeLoad: () => { throw redirect({ href: "/en/services/regulatory-toxicology/residual-solvents-reports", statusCode: 301 }); },
});
